import React, { useEffect, useState } from 'react';
import { Card, Button, Spin, Empty, message } from 'antd';
import { ScheduleOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import ScheduleList from './ScheduelList';
import ScheduleModal from '../Modals/SchedualModal';
import { useSchedules } from '../../hooks/usePatientData';
import drEasyApi from '../../Api/Customapi';


const ScheduleTab = ({
  patient,
  onCreate,
  onUpdate,
  onDelete,
  onRefresh,
  change
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState(null);
  const [loading, setLoading] = useState(false);
  const [schedules, setSchedules] = useState([]);

  const fetchSchedules = async () => {
    if (!patient?.accountId) return;

    setLoading(true);
    try {
      const response = await drEasyApi.get('/api/Schedule/GetUserSchedules', {
        params: { UserId: patient.accountId }
      });
      setSchedules(response.data || []);
    } catch (error) {
      console.error('Error fetching schedules:', error);
      message.error('Failed to load schedules');
      setSchedules([]);
    } finally {
      setLoading(false);
    }
  };


  const handleCreateSchedule = () => {
    setEditingSchedule(null);
    setModalVisible(true);
  };

  const handleEditSchedule = (schedule) => {
    setEditingSchedule(schedule);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setEditingSchedule(null);
  };
  const { refreshSchedules } = useSchedules();
  const handleScheduleSubmit = async (scheduleData) => {
    try {
      if (editingSchedule) {
        await onUpdate(editingSchedule.id, scheduleData);
      } else {
        await onCreate(scheduleData);
      }
      handleModalClose();
    } catch (error) {
      // Error handling is done in the hook
      console.error('Error submitting schedule:', error);
    }
  };
  const handleRefresh = () => {
    fetchSchedules();
  };

  useEffect(() => {
    fetchSchedules();
  }, [patient?.accountId, onDelete, onUpdate, onUpdate,change]);
  useEffect(() => {
    fetchSchedules();
  }, []);
  return (
    <>
      <Card
        title={
          <div className="flex justify-between items-center">
            <span className="text-primary font-medium">
              <ScheduleOutlined className="mr-2" />
              Patient Schedules
            </span>
            <div className="flex gap-2">
              <Button
                icon={<ReloadOutlined />}
                onClick={handleRefresh}
                loading={loading}
                className="hover:text-[#298d9f] hover:border-[#298d9f]"
              >
                Refresh
              </Button>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={handleCreateSchedule}
                className="bg-[#298d9f] hover:bg-[#206c7a]"
              >
                Add Schedule
              </Button>
            </div>
          </div>
        }
        bordered={false}
        className="bg-[#f9fafa]"
      >
        <Spin spinning={loading}>
          {schedules.length === 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <div className="text-center py-8">
                  <ScheduleOutlined className="text-4xl mb-2 block text-gray-400" />
                  <p className="text-gray-500">No schedules found for this patient</p>
                  <Button
                    type="primary"
                    onClick={handleCreateSchedule}
                    className="mt-2 bg-[#298d9f]"
                  >
                    Create First Schedule
                  </Button>
                </div>
              }
            />
          ) : (
            <ScheduleList
              schedules={schedules}
              onEdit={handleEditSchedule}
              onDelete={onDelete}
            />
          )}
        </Spin>
      </Card>

      <ScheduleModal
        visible={modalVisible}
        onClose={handleModalClose}
        onSubmit={handleScheduleSubmit}
        editingSchedule={editingSchedule}
        loading={loading}
      />
    </>
  );
};

ScheduleTab.propTypes = {
  schedules: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired
};

ScheduleTab.defaultProps = {
  loading: false
};

export default ScheduleTab;